// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Video-module--cds--assistive-text--809bf";
export var cdsVisuallyHidden = "Video-module--cds--visually-hidden--cb18c";
export var hideFeedback = "Video-module--hide-feedback--5e018";
export var showFeedback = "Video-module--show-feedback--cc054";
export var skeleton = "Video-module--skeleton--a2534";
export var video = "Video-module--video--f8946";
export var videoButton = "Video-module--video-button--aa9b3";
export var videoContainer = "Video-module--video-container--2ae7e";
export var videoIsPlaying = "Video-module--video--is-playing--e14ed";
export var vimeo = "Video-module--vimeo--77d77";